export const eldRoutes = {
  path: '',
  name: 'eld',
  component: () => import('@/layouts/Main.vue'),
  rule: 'editor',
  children: [
    {
      path: '/drivers',
      name: 'drivers',
      component: () => import('@/views/elds/drivers/DriversView.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'ELD' },
          { title: 'Drivers', active: true }
        ],
        pageTitle: 'Drivers',
        rule: 'editor',
        no_scroll: true
      }
    },
    {
      path: '/trackings',
      name: 'trackings',
      component: () => import('@/views/elds/trackings/trackingsView.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'ELD' },
          { title: 'Trackings', active: true }
        ],
        pageTitle: 'Trackings',
        rule: 'editor',
        no_scroll: true
      }
    },
    {
      path: '/tracking/:id',
      name: 'tracking',
      component: () => import('@/views/elds/trackings/trackingView.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'ELD' },
          { title: 'Tracking', active: true }
        ],
        pageTitle: 'Tracking',
        rule: 'editor',
        no_scroll: true
      }
    },
    {
      path: '/driving-events',
      name: 'driving-events',
      component: () => import('@/views/elds/events/EventsView.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'ELD' },
          { title: 'Driving Events', active: true }
        ],
        pageTitle: 'Driving Events',
        rule: 'editor',
        no_scroll: true
      }
    },
    {
      path: '/vehicles',
      name: 'Vehicles',
      component: () => import('@/views/elds/vehicles/VehiclesView.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'ELD' },
          { title: 'Vehicles', active: true }
        ],
        pageTitle: 'Vehicles',
        rule: 'editor',
        no_scroll: true
      }
    },
    {
      path: '/elds',
      name: 'elds',
      component: () => import('@/views/elds/elds/EldsView.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'ELD' },
          { title: 'ELDs', active: true }
        ],
        pageTitle: 'ELDs',
        rule: 'editor',
        no_scroll: true
      }
    },
    {
      path: '/transfer-eld-data',
      name: 'transfer-eld-data',
      component: () => import('@/views/elds/transfer/TransferView.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'ELD' },
          { title: 'Transfer ELD Data', active: true }
        ],
        pageTitle: 'Transfer ELD Data',
        rule: 'editor',
        no_scroll: true
      }
    },
  ],
}
